import React from 'react';
import { Box, Button } from '@mui/material';
import logo from '../assets/logo.png';

export default function HeaderSection() {
  const handleScrollToProduct = () => {
    const productSection = document.getElementById('product-section');
    if (productSection) {
      productSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <Box sx={{ 
      position: 'absolute', 
      top: 0, 
      left: 0, 
      width: '100%', 
      zIndex: 2,
      px: { xs: 0, sm: 0, md: 0, lg: 0 },
      pt: { xs: 3, sm: 4, md: 5, lg: 7 }
    }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        maxWidth: '1900px',
        margin: '0 0',
        width: '100%',
        // Use horizontal padding to position header elements instead of element margins
        px: { xs: 2.5, sm: 3, md: 3, lg: 15 }
      }}>
        <Box
          component="img"
          src={logo}
          alt="Ixoria Logo"
          sx={{
            // Reduced logo heights to decrease overall header height
            height: { xs: 22, sm: 30, md: 34, lg: 60 },
            width: 'auto',
            objectFit: 'contain',
            // Removed left margin; spacing handled by container padding
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleScrollToProduct}
          sx={{
            borderRadius: 30,
            textTransform: 'none',
            fontWeight: { xs: 450, sm: 500 },
            fontSize: { xs: 10, sm: 11, md: 12, lg: 18 },
            py: { xs: 0.8, sm: 1 },
            px: { xs: 2, sm: 3 },
            whiteSpace: 'nowrap',
            // Removed right margin; spacing handled by container padding
          }}
        >
          Order Face Mask
        </Button>
      </Box>
    </Box>
  );
}
